import { render, staticRenderFns } from "./CommonAuthComponent.vue?vue&type=template&id=0755e8a6"
import script from "./CommonAuthComponent.vue?vue&type=script&lang=js"
export * from "./CommonAuthComponent.vue?vue&type=script&lang=js"
import style0 from "./CommonAuthComponent.vue?vue&type=style&index=0&id=0755e8a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports